import { render, staticRenderFns } from "./UnfinishNotice.vue?vue&type=template&id=38e75938&scoped=true&"
import script from "./UnfinishNotice.vue?vue&type=script&lang=js&"
export * from "./UnfinishNotice.vue?vue&type=script&lang=js&"
import style0 from "./UnfinishNotice.vue?vue&type=style&index=0&id=38e75938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e75938",
  null
  
)

export default component.exports